var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen flex w-full bg-img"},[_c('div',{staticClass:"vx-col flex items-center justify-center flex-col mx-auto text-center"},[_c('p',{staticClass:"sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text-inverse font-30"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }